import { all } from 'redux-saga/effects'
import { watchInitLoad } from './watchInitLoad'
import { watchLoadAll } from './watchLoadAll'

export default function* loadAllSaga() {
    yield all([
        watchInitLoad(),
        watchLoadAll()
    ])
}